import React, { useState, useRef, useEffect } from "react";
function FemaleLandingPageVideoComponent({location}) {
  const [openVideo, setOpenVideo] = useState(null);

  const videos = [
   

    "https://bhumuweb-media-avd-store.s3.ap-south-1.amazonaws.com/glazmaVideo/forfemale/glazma+reels+2.mp4",
    "https://bhumuweb-media-avd-store.s3.ap-south-1.amazonaws.com/glazmaVideo/forfemale/glazma+reels+4.mp4",
    "https://bhumuweb-media-avd-store.s3.ap-south-1.amazonaws.com/glazmaVideo/forfemale/glazma+reels+1.mp4",
    "https://bhumuweb-media-avd-store.s3.ap-south-1.amazonaws.com/glazmaVideo/forfemale/glazma+reels+3.mp4",
    "https://bhumuweb-media-avd-store.s3.ap-south-1.amazonaws.com/glazmaVideo/forfemale/glazma+reels+5.mp4"
  
  ];

  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.01] } 
    );

    videoRefs.current.forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      videoRefs.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, []);

  return (
    <>
      <div className="test-home-video-bg" style={{backgroundColor:"#f8f7f3"}}>
        <div className="test-home-video-main  female-landing-page-manage-padding">
        

  

{/* _________________________________________________________________Heading Text  ______________________________________________________________________________________ */}
    
    
    
          <div className="test-home-video-cont"  >

            {videos.map((src, i) => (
              <div
                className="test-home-video-box"
                key={i}
                onClick={() => setOpenVideo(src)}
              >
                <video
                  src={src}
                  ref={(el) => (videoRefs.current[i] = el)}
                  className="video-player"
                  muted
                  loop
                  playsInline
                />
              </div>
            ))}
          </div>



            <div id="services" ></div>


{/* For Phone Only ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::; */}


        </div>
      </div>

      {openVideo && (
        <div className="popup-overlay">
          <div className="popup-close" onClick={() => setOpenVideo(null)}>
            ✕
          </div>
          <div className="popup-video-container">
            <video
              src={openVideo}
              controls
              autoPlay
              muted
              loop
              className="popup-video"
              playsInline
            />
          </div>
        </div>
      )}
    </>
  );
}

export default FemaleLandingPageVideoComponent;



// export default FemaleLandingPageVideoComponent